/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../store/actions";
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import {
	FormControl,
	Button,
	IconButton
} from '@mui/material';
import { FilterList } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';
import { DivFormTitle } from './styles';
import Autocomplete from '../../../../UI/Autocomplete/Autocomplete';

const LogsSuperadminModalFilter = (props) => {
	const dispatch = useDispatch();

	const [page] = useState(1);
	const [limit] = useState(25);
	const [orderBy] = useState("createdAt");
	const [order] = useState("asc");

	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);

	const [searchTextEmailTypes, setSearchTextEmailTypes] = useState('');
	const [selectedEmailTypes, setSelectedEmailTypes] = useState([])

	const [searchTextTenants, setSearchTextTenants] = useState('');
	const [tenantsFormated, setTenantsFormated] = useState([]);
	const [selectedTenants, setSelectedTenants] = useState([])

	const fetchTenants = useCallback(
		() => dispatch(actions.fetchEmailLogsOptionsTenants(page, limit, searchTextTenants, order, orderBy)),
		[page, limit, searchTextTenants, order, orderBy]
	);

	const emailTypes = useSelector(state => state.emailLogs.emailTypes);

	const emailLogsFilter = useSelector(state => state.emailLogs.emailLogsFilter);
	const filteredStartDate = useSelector(state => state.emailLogs.emailLogsFilter.startDate);
	const filteredEndDate = useSelector(state => state.emailLogs.emailLogsFilter.endDate);
	const filteredEmailTypes = useSelector(state => state.emailLogs.emailLogsFilter.filteredEmailTypes);
	const filteredTenants = useSelector(state => state.emailLogs.emailLogsFilter.filteredTenants)

	const loadingTenants = useSelector(state => state.emailLogs.loadingTenants);
	const tenants = useSelector(state => state.emailLogs.tenants);

	useEffect(() => {
		handleInputChangeEmailTypes(filteredEmailTypes);
		handleInputChangeTenants(filteredTenants);
		setStartDate(filteredStartDate ? filteredStartDate : null);
		setEndDate(filteredEndDate ? filteredEndDate : null);
	}, []);

	useEffect(() => {
		fetchTenants(limit, searchTextTenants, order, orderBy);
	}, [searchTextTenants]);

	useEffect(() => {
		const dataFromRedux = tenants
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
		setTenantsFormated(returnArray)
	}, [tenants])

	const handleInputChangeSelectorEmailTypes = (text) => {
		setSearchTextEmailTypes(text);
	} 

	const handleInputChangeSelectorTenants = (text) => {
		setSearchTextTenants(text);
	} 

	const handleInputChangeEmailTypes = selected => {
		setSelectedEmailTypes(selected);
	}

	const handleInputChangeTenants = selected => {
		setSelectedTenants(selected);
	}

	const handleClickFilter = () => {
		dispatch(actions.fetchEmailLogs(page, emailLogsFilter.limit, emailLogsFilter.search, emailLogsFilter.order, emailLogsFilter.orderBy, startDate, endDate, selectedEmailTypes, selectedTenants))
		props.closeModal();
	}

	const handleClickClearFilters = () => {
		setSelectedEmailTypes([])
		setSelectedTenants([])
		setStartDate(null)
		setEndDate(null)
	}

	return (
        <div style={styles.container}>			
			<DivFormTitle style={styles.headerContainer}>
				<div style={{ display: 'flex', alignItems: 'center', fontSize: '1.25rem' }}>
					<FilterList style={{ marginRight: '1rem' }} />
					FILTROS
					{(selectedEmailTypes && selectedEmailTypes.length > 0)
					&& <div style={styles.clearFilter} onClick={handleClickClearFilters}>limpar filtros</div>}
				</div>
				<IconButton onClick={props.closeModal} color='inherit' size="large">
					<CloseIcon />
				</IconButton>
			</DivFormTitle>
			<div style={styles.bodyContainer}>
			<div style={{ display: 'flex', justifyContent: 'space-between' }}>	
					<FormControl variant="standard" style={{ width: '45%' }} margin='normal'>
						<MobileDateTimePicker
							label='Data de criação de:'
							margin='normal'
							value={startDate && new Date(startDate)}
							onChange={date => setStartDate(date ?  date : null)}
							format="dd/MM/yyyy HH:mm"
							ampm={false}
							disableFuture
							slotProps={{ textField: { variant: 'standard', } }}
						/>
					</FormControl>
					<FormControl variant="standard" style={{ width: '45%' }} margin='normal'>
						<MobileDateTimePicker
							label='Data de criação até:'
							margin='normal'
							value={endDate && new Date(endDate)}
							onChange={date => setEndDate(date ?  date : null)}
							format="dd/MM/yyyy HH:mm"
							disableFuture
							ampm={false}
							slotProps={{ textField: { variant: 'standard', } }}
						/>
					</FormControl>
				</div>
			<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						label='Tipo'
						data={emailTypes}
						onSelectValue={handleInputChangeEmailTypes}
						valueSelected={selectedEmailTypes}
						newSearchText={handleInputChangeSelectorEmailTypes}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingTenants}
						label='Tenants'
						data={tenantsFormated}
						onSelectValue={handleInputChangeTenants}
						valueSelected={selectedTenants}
						newSearchText={handleInputChangeSelectorTenants}
						isMulti
					/>
				</FormControl>
			</div>
			<div style={styles.footerContainer}>
				<div
					onClick={props.closeModal}
					style={styles.buttonCancel}
				>
					CANCELAR
				</div>
				<Button
					variant='contained'
					color='primary'
					onClick={handleClickFilter}
					style={styles.button}
				>
					APLICAR
				</Button>
			</div>
		</div>
    );
}

const styles = {
	container: {
		width: '40rem',
		height: '100%'
	},
	headerContainer: {
		height: '5rem',
		padding: '0 1rem 0 2rem',
		backgroundColor: '#008100',
		color: '#fff',
	},
	bodyContainer: {
		height: 'calc(100% - 10rem)',
		padding: '1rem 2rem',
		overflowY: 'auto',
		borderTop: '1px solid #ccc',
		borderBottom: '1px solid #ccc',
	},
	chip: {
		display: 'flex',
		alignItems: 'center',
		backgroundColor: '#C5D1E3',
		margin: '0.5rem 0',
		borderRadius: 10,
		padding: '0.3rem 1rem',
		justifyContent: 'space-between'
	},
	footerContainer: {
		height: '5rem',
		padding: '0 2rem',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	button: {
		flex: 1,
		backgroundColor: '#008100',
		borderRadius: '2rem',
		padding: '0.5rem 1.5rem',
		// width: '100%',
	},
	buttonCancel: {
		flex: 1,
		cursor: 'pointer',
		color: 'grey',
		alignItems: 'center',
		textAlign: 'center',
	},
	clearFilter: {
		fontSize: '1rem', 
		marginLeft: '2rem', 
		color: '#fff', 
		cursor: 'pointer', 
		textDecoration: 'underline' 
	}
}


export default LogsSuperadminModalFilter;

